import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProPage } from '../../../components/Page/Page';
import { getBASE_MenuData } from '../../../constants/menu';
import { ApplicationDetailStartPage } from '../../../modules/AreaStartPage/AreaStartPage';

export const TeamWelcomePage = () => {
    const { t } = useTranslation();
    return (
        <ProPage
            // breadCrump={getBaseBCItemForType([ApplicationElementType.TeamManagement], t)}
            name={t('navigation.teamMan.base')}
        >
            <ApplicationDetailStartPage data={getBASE_MenuData(t)[1]} />
        </ProPage>
    );
};
